import React from "react";
import AirlineSeatIndividualSuiteIcon from "@mui/icons-material/AirlineSeatIndividualSuite";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";

function Capacity({ capacity, usedCapacity }) {
  return (
    <>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <AirlineSeatIndividualSuiteIcon />
          </Avatar>
        </ListItemAvatar>
        <Typography component="div" sx={{ fontSize: "2rem", fontWeight: 500 }}>
          Kapacita
        </Typography>
      </ListItem>
      <ListItem sx={{ pl: 4, pb: 0 }}>
        <Typography component={"div"} sx={{ fontSize: "1.8rem" }}>
          Celková kapacita: {capacity}
        </Typography>
      </ListItem>
      <ListItem sx={{ pl: 4, pt: 0 }}>
        <Typography component={"div"} sx={{ fontSize: "1.8rem" }}>
          Obsadené: {usedCapacity}
        </Typography>
      </ListItem>
    </>
  );
}

export default Capacity;
